/*
 * @Descripttion:
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, { useEffect, useState } from 'react';
import MarketingComponent from './components/marketing';
import styles from './index.module.scss';
import { CanvasService } from '@/service';
import utils from '@/common/utils';

export default (props) => {
  // 活动名称
  const [compagainName, setCompagainName] = useState('');
  // tab 状态
  const [currentKey, setCurrentKey] = useState(1);
  // 组合参数传给子组件
  const [composeProps, setComposeProps] = useState({
    location: {
      state: {
        data: {
          id: 0,
          processKey: '',
          executionPlan: {
            type: 0,
          },
          campaignName: '',
          campaignState: 0,
          taskType: 0,
        },
      },
    },
  });

  /**
   * 获取详情
   */
  const getActivityDetail = async (id) => {
    CanvasService.getCanvasProcessDetail({ campaignId: id })
      .then((res) => {
        setCompagainName(res.data.campaign.campaignName);
        const buff = { ...composeProps };
        // console.log(res.data);
        let taskType;
        if (res.data?.processDesignModel?.childShapes) {
          const arr = res.data?.processDesignModel?.childShapes;
          const typeArr = [];
          arr.forEach((item) => {
            typeArr.push(item.resourceType);
          });
          // 只有仅存在优惠促销时传5，仅存富信时，传11，其他情况【即包含短信时】传4
          if (
            typeArr.includes('MARKETING_MSG_BOX') &&
            !typeArr.includes('MARKETING_SMS')
          ) {
            taskType = 5;
          } else if ((typeArr.includes('MARKETING_RICH_SMS') || typeArr.includes('MARKETING_RICH_TEXT_SMS')) && !typeArr.includes('MARKETING_SMS') && !typeArr.includes('MARKETING_MSG_BOX')) {
              taskType = 11;
          } else if (typeArr.includes('MARKETING_SMS')) {
            taskType = 4;
          } else if (typeArr.includes('MARKETING_DONGDONG')) {
            taskType = 8;
          } else {
            taskType = 1;
          }
        }
        buff.location.state.data.id = props.match.params.id;
        buff.location.state.data.processKey = res.data.campaign.processKey;
        buff.location.state.data.executionPlan.type =
          res.data.campaign.executionPlan.type;
        buff.location.state.data.campaignName = res.data.campaign.campaignName;
        buff.location.state.data.campaignState =
          res.data.campaign.campaignState;
        buff.location.state.data.taskType = taskType;
        setComposeProps({ ...buff });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    getActivityDetail(props.match.params.id);

    utils.setBreadcrumb({
      name: '营销画布', // 一级页面名称
      url: '/web/canvas/activities', // 一级页面url
      children: {
        name: '报表', // 二级页面名称
        url: '/web/canvas/activities', // 二级页面url
        // children: {
        //   name: breadcrumbThree, // 三级页面名称
        //   url: '/web/crowdMarketing/create', // 三级页面url
        // },
      },
    });
  }, []);

  return (
    <div className={styles['canvas-analysis-div']}>
      <div className={styles['page-title']}>计划报表-{compagainName}</div>
      {/* <div className="first-level">
        <Tab
          size="medium"
          activeKey={currentKey}
          onChange={(v) => setCurrentKey(v)}
        >
          <Tab.Item title="营销" key="1">
            {composeProps.location.state.data.id !== 0 && (
              <MarketingComponent datasource={composeProps} />
            )}
          </Tab.Item>
          {
            venderType === '0' &&
            <Tab.Item title="权益" key="2">
              <EquityComponent datasource={composeProps} />
            </Tab.Item>
          }
        </Tab>
      </div> */}
        {composeProps.location.state.data.id !== 0 && (
            <MarketingComponent datasource={composeProps} />
        )}
    </div>
  );
};
